// Stimulus controllers index
// This file auto-registers all controllers in this directory

import { Application } from '@hotwired/stimulus'

// Auto-register controllers from this directory
// Import all controller files
import AlertController from './alert_controller'
import DropdownController from './dropdown_controller'
import FormController from './form_controller'
import ToggleController from './toggle_controller'
import FlashController from './flash_controller'
import ConfirmController from './confirm_controller'
import SearchController from './search_controller'
import DeliveryZoneMapController from './delivery_zone_map_controller'
import DeliveryZonePreviewController from './delivery_zone_preview_controller'
import NestedListController from './nested_list_controller'
import PromoRuleFieldsController from './promo_rule_fields_controller'

const application = Application.start()

// Configure Stimulus development experience
application.debug = process.env.NODE_ENV === 'development'
window.Stimulus = application

// Register controllers
application.register('alert', AlertController)
application.register('dropdown', DropdownController)
application.register('form', FormController)
application.register('toggle', ToggleController)
application.register('flash', FlashController)
application.register('confirm', ConfirmController)
application.register('search', SearchController)
application.register('delivery-zone-map', DeliveryZoneMapController)
application.register('delivery-zone-preview', DeliveryZonePreviewController)
application.register('nested-list', NestedListController)
application.register('promo-rule-fields', PromoRuleFieldsController)

export { application }
